import React from "react";
import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "447424311882";
const MESSAGE = "Hello MAVULA! I want to know more about owning a home. Please help me.";

export default function WhatsAppButton() {
  const { t } = useTranslation();
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      className="fixed z-40 bottom-5 left-5 flex items-center gap-3 rounded-full pl-3 pr-5 py-3 shadow-lg mv-pulse"
      style={{ background: "var(--mv-whatsapp)", color: "#fff" }}
      aria-label="Chat with us on WhatsApp"
    >
      <span className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center">
        <MessageCircle size={22} strokeWidth={2} />
      </span>
      <span className="hidden sm:flex flex-col leading-tight">
        <span className="font-semibold text-[14px]">{t("whatsapp.label")}</span>
        <span className="text-[11px] text-white/85">{t("whatsapp.sub")}</span>
        <span className="text-[10px] mt-0.5 px-1.5 py-0.5 rounded-full font-semibold self-start" style={{ background: "rgba(255,255,255,0.22)" }}>Reply within 24 hrs</span>
      </span>
    </a>
  );
}
